import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FormEventComponent from '../components/FormEventComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

var config = process.env;

class AddEventPage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0, disabled: false };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
    }

    handleChangeData = (value, ticketType) => {
        this.setState({ disabled: true });
        const headers = {
            'Content-Type': 'application/json',
            'access-token': localStorage.getItem('token'),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'manage-events', {
            method: 'POST', headers, body: JSON.stringify(value),
        })
            .then((results) => results.json())
            .then(async (data) => {
                if (data.error > 0) {
                    // ENI-116: el mensaje de negocio (validación de startsAt/capacity, etc.) viene anidado en data.data.message
                    alert((data.data && data.data.message) || data.message);
                    this.setState({ disabled: false });
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                    return;
                }
                const newId = data.data && data.data.event && data.data.event.id;
                // Crear la entrada inicial (tipo de entrada) del evento recién creado.
                if (newId && ticketType) {
                    await fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `manage-events/${newId}/ticket-types`, {
                        method: 'POST', headers, body: JSON.stringify(ticketType),
                    }).then((r) => r.json()).catch(() => {});
                }
                // Ir a edición para agregar más tipos / publicar.
                navigateTo(newId ? `/editEvent?id=${newId}` : '/events');
            })
            .catch((error) => {
                console.error('No se pudo crear el evento:', error);
                alert('Error de conexión');
                this.setState({ disabled: false });
            });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={33} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Eventos" subtitle="Nuevo evento" />
                            <FormEventComponent
                                onChangeData={this.handleChangeData}
                                disabled={this.state.disabled}
                            />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default AddEventPage;
